import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M11 16H5.00004C4.22825 16 3.74738 15.1628 4.13626 14.4961L11.1363 2.49612C11.6506 1.61443 13 1.97925 13 2.99999V7.99999H19C19.7718 7.99999 20.2527 8.8372 19.8638 9.50386L12.8638 21.5039C12.3495 22.3855 11 22.0207 11 21V16ZM11 6.69891L6.74108 14H12C12.5523 14 13 14.4477 13 15V17.3011L17.259 9.99999H12C11.4478 9.99999 11 9.55227 11 8.99999V6.69891Z" />,
  'Bolt'
);
